/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Callback_In_ProgressInputs */

const en_callback_in_progress = /** @type {(inputs: Callback_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing you in...`)
};

const fr_callback_in_progress = /** @type {(inputs: Callback_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification en cours...`)
};

const ms_sg2_callback_in_progress = /** @type {(inputs: Callback_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang log masuk anda...`)
};

/**
* | output |
* | --- |
* | "Signing you in..." |
*
* @param {Callback_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const callback_in_progress = /** @type {((inputs?: Callback_In_ProgressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Callback_In_ProgressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_callback_in_progress(inputs)
	if (locale === "fr") return fr_callback_in_progress(inputs)
	return ms_sg2_callback_in_progress(inputs)
});